import dayjs from "dayjs";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { ICustomField, useFormats } from "@ryde/shared";

import { GenericReadonly } from "../../common";

export const DateCountdownReadonlyTemplate: FC<ICustomField> = ({
  name,
  formLabel,
}) => {
  const { control } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  const { formatDateTimeNormalized } = useFormats();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value } }) => {
        return (
          <GenericReadonly
            label={formLabelTranslated}
            value={`${dayjs(value).fromNow()} (${formatDateTimeNormalized(value)})`}
          />
        );
      }}
    />
  );
};
